import { ProductSectionItemViewModel } from '../product-section-item/product-section-item-view-model';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SectionColumnConfigState } from '../../../../../../../../models/enum/shared/section-column-config-state';

@Injectable()
export class ReportNewProductSectionItemViewModel extends ProductSectionItemViewModel {
  public readonly imageColumnConfig$ = this.columnViewModels$.pipe(
    map(vms => vms?.find(columnViewModel => columnViewModel?.isAssetColumn()))
  );

  public readonly badgeConfig$ = this.fixedLocationViewModels$.pipe(
    map(vms => vms?.find(fixedLocation => fixedLocation?.isBadgeProperty()))
  );

  public readonly badgeEnabled$ = this.badgeConfig$.pipe(
    map(badgeColumnConfig => {
      const auto = badgeColumnConfig?.columnConfig.defaultState === SectionColumnConfigState.Auto;
      const on = badgeColumnConfig?.columnConfig.defaultState === SectionColumnConfigState.On;
      return auto || on;
    })
  );

  public readonly newProductColumnViewModels$ = this.columnViewModels$.pipe(
    map(vms => vms?.filter(columnViewModel => !columnViewModel?.isAssetColumn() && !columnViewModel?.isBadgeColumn()))
  );
}
